import {EuiButton, EuiFlexGroup, EuiFlexItem, EuiSpacer} from "@elastic/eui";
import {PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {FC, useState} from "react";

export interface IStripeAddPaymentElement {
    return_url: string
    onError?: (error: any) => void
    onBackClick?: () => void
    onRemoteSignClick?: () => void
    prePaymentAddedAsync?: () => Promise<void>;
    onPaymentAdded?: () => void
    isLoading?: boolean
    isDisabled?: boolean
    confirmText?: string
    backText?: string
    remoteSignText?: string
}

export const StripeAddPaymentElement: FC<IStripeAddPaymentElement> = props => {
    const stripe = useStripe()
    const elements = useElements()

    const [paymentLoading, setPaymentLoading] = useState<boolean>(false)

    const stripeConfirmSetup = () => {
        if (stripe && elements) {
            stripe
                .confirmSetup({
                    elements,
                    redirect: "if_required",
                    confirmParams: {
                        return_url: props.return_url
                    }
                })
                .then(result => {
                    const error = result.error
                    if (error) {
                        props.onError?.(error)
                    } else {
                        props.onPaymentAdded?.()
                    }
                    setPaymentLoading(false)
                })
        }
    }

    const onAddPaymentMethod = () => {
        if (stripe && elements) {
            setPaymentLoading(true)
            if (props.prePaymentAddedAsync) {
                props.prePaymentAddedAsync().then(() => {
                    setTimeout(() => {
                        stripeConfirmSetup()
                    }, 1000)
                })
            } else {
                stripeConfirmSetup()
            }
        }
    }

    return (
        <>
            <PaymentElement/>
            <EuiSpacer/>
            <EuiFlexGroup>
                {props.onBackClick && (
                    <EuiFlexItem grow={false}>
                        <EuiButton onClick={props.onBackClick} fill disabled={paymentLoading || props.isLoading}>{props.backText ? props.backText : 'Back'}</EuiButton>
                    </EuiFlexItem>
                )}
                <EuiFlexItem grow={false}>
                    <EuiButton onClick={onAddPaymentMethod} disabled={!stripe || !elements} isLoading={paymentLoading || props.isLoading} isDisabled={props.isDisabled} fill>
                        {props.confirmText ? props.confirmText : 'Confirm'}
                    </EuiButton>
                </EuiFlexItem>
                {props.onRemoteSignClick && (
                    <EuiFlexItem grow={false}>
                        <EuiButton onClick={props.onRemoteSignClick} fill disabled={paymentLoading || props.isLoading} color={'text'}>{props.remoteSignText ? props.remoteSignText : 'Remote Sign'}</EuiButton>
                    </EuiFlexItem>
                )}
            </EuiFlexGroup>
        </>
    )
}